import { getStore, lazyChangeNoteColor } from 'owa-notes-store';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import {
    yellow,
    green,
    pink,
    purple,
    blue,
    gray,
    charcoal,
} from 'owa-locstrings/lib/strings/notecolorstrings.locstring.json';

export const notesColorMap = {
    Yellow: { color: 'Yellow', text: yellow, styleColor: '#fff2ab' },
    Green: { color: 'Green', text: green, styleColor: '#cbf1c4' },
    Pink: { color: 'Pink', text: pink, styleColor: '#ffcce5' },
    Purple: { color: 'Purple', text: purple, styleColor: '#e7cfff' },
    Blue: { color: 'Blue', text: blue, styleColor: '#cde9ff' },
    Gray: { color: 'Gray', text: gray, styleColor: '#e1dfdd' },
    Charcoal: { color: 'Charcoal', text: charcoal, styleColor: '#484644' },
};

const handleClick = (
    ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
    item?: IContextualMenuItem
): boolean | void => {
    if (item) {
        lazyChangeNoteColor.importAndExecute(item.key, 'NotesFolder');
    }
};

export default function getChangeColorMenuProps(): IContextualMenuItem[] {
    const selectedNoteColor = getStore().selectedNoteColor;
    return Object.values(notesColorMap).map(colorMapValue => {
        return {
            key: colorMapValue.color,
            text: loc(colorMapValue.text),
            canCheck: true,
            checked: selectedNoteColor == colorMapValue.color,
            onClick: handleClick,
            iconProps: { iconName: ControlIcons.CircleFill },
            itemProps: { styles: { icon: { color: colorMapValue.styleColor } } },
        };
    });
}
